define('modules/editor/models/confirmation_page',['require','exports','module','./page'],function(require, exports, module){
  "use strict";
  var Page = require("./page");
  module.exports = Page.extend({
    invalidElements: ["form"],
    toJSON: function(){
      return {
        json: Page.prototype.toJSON.apply(this),
        html: this.get("html")
      };
    }
  });
});

